//The module wraps up the basic CRUD operations to interact with the server
//The Url parameter should includes all the parameters required to retrieve data from the server
//and they can be added to relevant functions in the service layer
//
import Axios from 'axios'

//
//Post data to server by POST method with authorization token
//
async function putData(url, data) {
    try {
        return await Axios.put(url, data);
    }
    catch (err) {
        throw err;
    }
    
} 

export default {
    putData
}